import type { AnalyzePrintingsRow, FailureBucket, PrintingStatus } from './types';
import { classifyPrinting } from './classifyPrinting';
import { bucketFailure } from './bucketFailure';

export type ChartFilter =
  | { kind: 'status'; value: Exclude<PrintingStatus, 'in-progress'> }
  | { kind: 'bucket'; value: FailureBucket }
  | null;

export const filterRowsByChart = (
  rows: AnalyzePrintingsRow[],
  chartFilter: ChartFilter
): AnalyzePrintingsRow[] => {
  if (!chartFilter) return rows;

  if (chartFilter.kind === 'status') {
    return rows.filter((r) => classifyPrinting(r) === chartFilter.value);
  }

  return rows.filter((r) => {
    if (classifyPrinting(r) !== 'failure') return false;
    return bucketFailure(r) === chartFilter.value;
  });
};
